import { useLang } from "../i18n";

const Cross = () => (
  <svg viewBox="0 0 20 20" className="h-3.5 w-3.5 shrink-0" aria-hidden="true">
    <rect width="20" height="20" rx="4" fill="#E60000" />
    <path d="M8.5 4h3v4.5H16v3h-4.5V16h-3v-4.5H4v-3h4.5V4z" fill="#fff" />
  </svg>
);

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee-section"
      className="relative overflow-hidden border-y border-slate-800/70 bg-[#0A101B] py-5"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg font-bold tracking-wide text-slate-300 sm:text-xl">
              {item}
            </span>
            <Cross />
          </span>
        ))}
      </div>
    </div>
  );
};
